import { useSelector } from "react-redux"
import styled from "styled-components"
import InputText from "../../../shared/input/new/InputText"
import { useEffect, useState } from "react"
import Btn from "../../../shared/button/Btn"
import { useDispatch } from "react-redux"
import MessageFileInput from "../../../shared/input/special/MessageFileInput"
import { updateBlogFAQ } from "../../../../features/admin3/admin3Slice"
import { Editor } from "@tinymce/tinymce-react"


const Container = styled.div`
    height: 100%;
    width: 100%;
    
    .blog-container{
        height: calc(100% - 120px);
        width: 100%;
        max-height: 4000px !important;
        overflow: auto;
        padding: 25px;
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 20px;
        .col{
            display: flex;
            flex-direction: column;
            gap: 5px;
            .error{
                font-size: var(--font-size-xs);
                font-weight: var(--font-weight-md);
                color: var(--color-main) !important;
            }
        }
        .img-container{
            display: flex;
            align-items: center;
            gap: 20px;
        }
    }
    .tox-statusbar__branding {
        display: none !important;
    }
`

const UpdateFAQ = ({data}) => {
    const dispatch = useDispatch()
    const {selectedBlog} = useSelector(state => state.admin3)
    const [listAndDetailImage, setListAndDetailImage] = useState(null)
    const [isSubmitting, setIsSubmitting] = useState(false)

    const [listData, setListData] = useState({
        question: "",
        answer: "",
        faqImageAlt: ""

    })

    const handleChange = (e) => {
        setListData({...listData, [e.target.name]: e.target.value})
    }

    const handleEditorChange = (answer) => {
        setListData({ ...listData, answer }); // Editor içeriğini güncelle
    };

    const handleCreateBlogList = () => {
        setIsSubmitting(true);
    
        if (listAndDetailImage && !listData.faqImageAlt) {
            return;
        }
    
        if (listData.question && listData.answer) {
            const imageToUpload = typeof listAndDetailImage === 'string' ? null : listAndDetailImage;
    
            const formData = new FormData();
            formData.append("question", listData.question);
            formData.append("answer", listData.answer);
            formData.append("faqImage", imageToUpload);
            formData.append("faqImageAlt", listData.faqImageAlt  || "");
            formData.append("blogId", selectedBlog.id);
            formData.append("id", data?.id);
    
            dispatch(updateBlogFAQ(formData));
        }
    };

    useEffect(() => {
        setListData({
            question: data?.question,
            answer: data?.answer,
            faqImageAlt: data?.faqImageAlt
        })
        setListAndDetailImage(data?.faqImage)
    }, [])

  return (

    <Container>

        <div className="blog-container">
            <div className="col">
                <InputText inputWidth={"100%"} data={listData.question} setData={(e) => handleChange(e)} name={"question"} labelText={"Soru"} />
                {isSubmitting && !listData.question &&
                    <p className="error">Zorunlu Alan!</p>
                }
            </div>
            <div className="col">

            <Editor
                apiKey="4b0bsl6u6sv8iqg9bh7giddxo16ulrl9whc4cmz46j7dsirn" // API anahtarınızı buraya koyun
                value={listData.answer}
                init={{
                    height: 500,
                    menubar: "format",
                    menu: {
                        format: { title: "Format", items: "bold underline blocks | removeformat" },
                    },
                    plugins: [ 
                        "link", "lists",
                        "advlist", "autolink", "charmap", "print", "preview", "anchor",
                        "searchreplace", "fullscreen",
                        "insertdatetime", "paste", "help", "wordcount", 
                    ],
                    toolbar:
                    "undo redo | formatselect | bold | \
                    bullist numlist outdent indent | link removeformat | help",
                }}
                onEditorChange={handleEditorChange}
                />
                {isSubmitting && !listData.answer &&
                    <p className="error">Zorunlu Alan!</p>
                }
            </div>
            <div className="img-container">
                <MessageFileInput setSelectedFile={setListAndDetailImage} />
                <InputText inputWidth={"100%"} data={listAndDetailImage?.name || listAndDetailImage} disabled={true} setData={(e) => handleChange(e)} name={"listAndDetailImage"} labelText={"Bloglar Listesi Görseli ve Detay Sayfası Ana Görsel"} />
            </div>
            <div className="col">
                <InputText inputWidth={"100%"} data={listData?.faqImageAlt} setData={(e) => handleChange(e)} name={"faqImageAlt"} labelText={"Alt Etiketi"} />
                {isSubmitting && !listData.faqImageAlt && listAndDetailImage &&
                    <p className="error">Zorunlu Alan!</p>
                }
            </div>

            <div className="btn-container">
                <Btn width={"200px"} color="#E85446" bgColor="transparent" padding="0 10px" handleClick={handleCreateBlogList} >Güncelle</Btn>
            </div>
        </div>
         
    </Container>
  )
}

export default UpdateFAQ